// Copyright (c) 2017+,COMUNICARE SOLUTIONS SA
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without modification,
// are NOT permitted.

/**
 * Simple Object to store Key Value pair
 */
export interface IKeyValue {
  key: any;
  value: any;
}

export class KeyValue implements IKeyValue {
  public static get KV_ACTION_EDIT(): string {
    return "edit";
  }
  public static get KV_ACTION_VIEW(): string {
    return "view";
  }

  public key: any;
  public value: any;

  constructor(key?: any, value?: any) {
    this.setKeyValue(key, value);
  }

  public setKeyValue(key: any, value: any): void {
    this.key = key;
    this.value = value;
  }

  /**
   * This method can be used to prevent KeyValue from reordering the datas
   * @returns 0
   */
  public static keepOriginalOrder(): number {
    return 0;
  }
}

/**
 * Simple class to handle 3 values
 */
export class KeyValueExtra {
  constructor(public key: any, public value: any, public extra: any) {
    this.setKeyValue(key, value, extra);
  }

  public setKeyValue(key: any, value: any, extra: any): void {
    this.key = key;
    this.value = value;
    this.extra = extra;
  }
}
